export default {
  delay: 6000,
  type: {
    WARNING: 'WARNING',
    ERROR: 'ERROR',
    SUCCESS: 'SUCCESS',
    INFO: 'INFO'
  },
  icons: {
    WARNING: 'icon-Warning-important',
    ERROR: 'icon-error-severe',
    SUCCESS: 'icon-tick-circle',
    INFO: 'icon-info'
  }
}
